import React from 'react'
import { TemplateProps, useChatWhatsApp } from '../../../../../context/ChatWhatsAppContext'
import { useFila } from '../../../../../context/FilaContext'
import { apiWhatsApp } from '../../../../../services/api'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useAuth } from '../../../../../context/AuthContext'

// template: { template: TemplateProps }
export const Templates = () => {
  const { enviarTemplate, enviarMessages } = useChatWhatsApp()
  const { devedorFilaSelected } = useFila()
  const { cookies } = useAuth()
  const queryClient = useQueryClient()

  async function handleClick() {

    const templateToSend = {
      namespace: 'cff93b07_25ff_4af5_937a_5d720edd0d44',
      name: 'abordagem_2',
      language: {
        policy: "deterministic",
        code: "pt_BR"
      },
      components: [
        {
          type: "body",
          parameters: [
            {
              type: "text",
              text: `${devedorFilaSelected?.name?.split(' ')[0]}`
            },
            {
              type: "text",
              text: `${cookies?.user?.nome?.split(' ')[0]}`
            },
            // {
            //   type: "text",
            //   text: `${selectedCredor?.nome}`
            // },
          ]
        }
      ]
    }
    await enviarTemplate({ type: 'template', template: templateToSend, onlySave: false, token: cookies?.whatsapp?.token || '', chat: devedorFilaSelected.id_chat })

    await enviarMessages({ type: 'text', text: 'Enviado template de inicio de conversa', onlySave: true, token: cookies?.whatsapp?.token || '', chat: devedorFilaSelected.id_chat })

    await queryClient.refetchQueries({ queryKey: ['firstMessages'] })
  }

  return (
    <div className='grid grid-cols-2 gap-1 text-xs text-ellipsis w-full'>
      {/* {
        data && data?.data && data?.data?.templates?.map((temp: { template: TemplateProps }) => (
          <div className='bg-white flex justify-center p-2 cursor-pointer rounded-md hover:brightness-95 ' onClick={() => handleClick(temp)} key={temp.template.name}>
            <p>TEMPLATE DE ABERTURA</p>
          </div>
        ))
      } */}
      <div className='bg-white flex justify-center p-2 cursor-pointer rounded-md hover:brightness-95 ' onClick={() => handleClick()}>
        <p>TEMPLATE DE ABERTURA</p>
      </div>
    </div>
  )
}